@let currentBooking = booking();

<div class="booking-card__top">
  <span class="ui-label-m-bold">{{ currentBooking.id }}</span>
  <rds-badge
    size="m"
    type="minimal"
    [color]="currentBooking.status.color"
    [label]="currentBooking.status.text"></rds-badge>
</div>
<span class="ui-body-m-bold">{{ currentBooking.eventName }}</span>
<span>{{ currentBooking.roomDescription }}</span>
<span class="booking-card__meta">
  {{ currentBooking.startDate | eventDateTime: currentBooking.endDate }}
</span>
<span class="booking-card__meta">{{ requesterNames() }}</span>
@if (serviceBadges().length > 0) {
  <div class="badge-container">
    @for (service of serviceBadges(); track $index) {
      <rds-badge
        size="m"
        type="minimal"
        [color]="service.color"
        [label]="service.text"></rds-badge>
    }
  </div>
}
